import { render, staticRenderFns } from "./RenewalReceipt.vue?vue&type=template&id=3ebee3a9&scoped=true"
import script from "./RenewalReceipt.vue?vue&type=script&lang=js"
export * from "./RenewalReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebee3a9",
  null
  
)

export default component.exports